import { Box, Typography } from "@mui/material";
import { Filter } from "pepsico-ds";
import CustomSearch from "../../../../../utils/CustomSearch/CustomSearch";

const SelectionHeader = ({
  selectedRows = [],
  handleSearch,
  handleSubject,
  subjectFilter = [],
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {/* Header with Title and Search */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          sx={{
            color: "var(--Tokens-Text-Primary, #3A3A3A)",
            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
            fontSize: "var(--Font-Size-H4, 28px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H4, 40px)",
            fontFeatureSettings: `'liga' off, 'clig' off`,
          }}
        >
          Available items
        </Typography>

        {/* 🔍 Custom Search */}
        <CustomSearch handleSearch={handleSearch} />
      </Box>

      {/* Filter and selection count */}
      <Box
        sx={{
          display: "flex",
          padding: "var(--Spacing-spacing-8, 8px)",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "var(--Spacing-spacing-8, 8px)",
          alignSelf: "stretch",
          background: "var(--Tokens-Background-Layer-01, #FBFCFE)",
          boxShadow: "0 -2px 0 0 #D7E5F8 inset",
        }}
      >
        <Filter
          label={
            <span
              style={{ fontSize: ".75rem", fontFamily: "Inter" }}
              data-testid="subject"
            >
              Subject
            </span>
          }
          onChange={handleSubject}
          options={subjectFilter.map((item) => ({
            id: item.id,
            label: item.name,
          }))}
          selection="single"
          size="medium"
          className="font-[Inter] text-[14px]"
        />

        {/* Selected Count */}
        <Typography
          sx={{
            color: "var(--Tokens-Text-Secondary, #616161)",
            fontFamily: "var(--Typography-Font-Family-Body, Inter)",
            fontSize: "var(--Font-Size-Small, 14px)",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "var(--Line-Height-Small, 20px)",
          }}
        >
          {`${selectedRows?.length} item(s) selected`}
        </Typography>
      </Box>
    </Box>
  );
};

export default SelectionHeader;
